module.exports = __webpack_public_path__ + "media/images/portal/i-t-afa246952a68953224b297446668a2b2.png";